export default [
  {
    path: 'installments',
    name: 'list-debt-installments',
    component: () =>
      import(
        /* webpackChunkName: "list-debt-installments" */ './list/index.vue'
      ),
    meta: {
      title: 'Công nợ dịch vụ trả góp - Clickbuy',
    },
  },
];
